import React, { Component }  from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import store from './components/store/store'
import registerServiceWorker from './registerServiceWorker';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { SnackbarProvider } from 'notistack';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
class NewVersionAlert extends Component {
    static displayName = App.name;
    constructor(props) {
        super(props);
        this.state = {
            open: true
        };
    }
    render() {
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={this.state.open}
                onClose={() => this.setState({ open: false })}
                message="A new version of the app is available, please refresh your browser."
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => this.setState({ open: false })}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        );
    }
}
const onUpdate = () => {
    // show alert
    console.log("onUpdate");
    const d = document.createElement("div")
    d.id = "newversion-alert";
    rootElement.appendChild(d);
    ReactDOM.render(<NewVersionAlert />, document.getElementById("newversion-alert"));
}

let persistor = persistStore(store);
ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
            <SnackbarProvider>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <App />
                </PersistGate>
            </Provider>
            </SnackbarProvider>
        </BrowserRouter>
    ,
  rootElement);

registerServiceWorker(onUpdate);
